module.exports = __webpack_public_path__ + "img/logo-CNA-big.64593c3c.png";